<script lang="ts" setup>
  import { fetchMedia } from '@/shared/lib';
  import { DSCVR_STATIC_ASSETS_CDN_URL } from '@/common';
  import { Banner } from '@/shared/ui/banner';
  import { useStorage } from '@vueuse/core';

  defineProps<{
    banner: any[];
  }>();

  const disabledSolanaMobileBannerFlag = useStorage(
    'disabled-solana-mobile-banner-flag-2',
    false,
  );
</script>

<template>
  <banner
    :hide-banner="disabledSolanaMobileBannerFlag"
    variant="colored"
    size="large"
    position="relative"
    :custom-classes="{
      background: 'bg-cover bg-no-repeat bg-center',
      text: 'text-white',
      border: '',
    }"
    :style="{
      backgroundImage: `url('${fetchMedia(
        `${DSCVR_STATIC_ASSETS_CDN_URL}/banner/bg-solana-non-mobile-banner.png`,
      )}')`,
    }"
    border="rounded-xl"
    :timed="false"
    inner-height="h-full"
    outer-width="w-full"
    class="mb-3"
    :show-close-button="false"
    z-index="z-1"
    @close="disabledSolanaMobileBannerFlag = true"
  >
    <template #photo>
      <div class="absolute">
        <img
          :src="
            fetchMedia(banner[0].image, {
              width: 72,
              height: 72,
              fit: 'cover',
              quality: 75,
            })
          "
          class="size-18"
          alt="Become an explorer"
        />
      </div>
    </template>
    <template #description>
      <span class="font-semibold">{{ banner[0].copy_first }}</span>
      <span>{{ banner[0].copy_second }}</span>
    </template>
    <template #button>
      <base-button
        variant="custom"
        custom-classes="flex items-center justify-center ease-transition-all px-2 py-1.5 rounded-full bg-white bg-opacity-8 hover:bg-opacity-12 border border-white border-opacity-8 backdrop-blur font-medium shadow-[0px_4px_16px_0px_rgba(0, 0, 0, 0.40)] mr-4"
        :to="banner[0].cta_link"
        target="_blank"
      >
        {{ banner[0].cta_label }}
      </base-button>
    </template>
  </banner>
</template>
